"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unaryPlusDependencies = void 0;
var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var unaryPlusDependencies = exports.unaryPlusDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createUnaryPlus: _factoriesAny.createUnaryPlus
};